"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BaseComponent = /** @class */ (function () {
    function BaseComponent($view) {
        this.$view = $view;
    }
    return BaseComponent;
}());
exports.default = BaseComponent;
